import { handleActions } from 'redux-actions';

import { coreActions } from 'companion-app-components/flux/core-actions';

import {
  appSetOnlineStatus,
  appSetServiceWorkerIsRegistered,
  appSetServiceWorkerIsRegistering,
  appSetServiceWorkerUpdateIsAvailable,
  setAwaitingToAutoRefresh,
  setAppProps,
} from 'data/app/actions';
import { importDataSuccess, importDataFailure } from 'data/import/importActions';
import { createJobStatus, deleteJobStatus } from 'data/jobStatus/actions';

import { mkAppStore, AppStore } from './types';

// redux-actions types meta as `unknown` regardless of action generic — cast handlers map to allow destructuring
const reducer = handleActions<
AppStore,
| ReturnType<typeof appSetOnlineStatus>
| ReturnType<typeof appSetServiceWorkerIsRegistered>
| ReturnType<typeof appSetServiceWorkerIsRegistering>
| ReturnType<typeof appSetServiceWorkerUpdateIsAvailable>
| ReturnType<typeof coreActions.sanitize>
| ReturnType<typeof coreActions.persistDataLoadComplete>
| ReturnType<typeof setAwaitingToAutoRefresh>
| ReturnType<typeof createJobStatus>
| ReturnType<typeof deleteJobStatus>
| ReturnType<typeof setAppProps>
| ReturnType<typeof coreActions.setUpdateAllState>
| ReturnType<typeof importDataSuccess>
| ReturnType<typeof importDataFailure>
>({

  [appSetOnlineStatus.toString()]: (state, { payload: value }) => state.merge({ isOffline: !value }),

  [appSetServiceWorkerIsRegistered.toString()]: (state, { payload: value }) =>
    state.merge({ serviceWorkerIsRegistered: value, serviceWorkerIsRegistering: false }),
  [appSetServiceWorkerIsRegistering.toString()]: (state, { payload: value }) =>
    state.merge({ serviceWorkerIsRegistering: value, serviceWorkerIsRegistered: value ? false : state.serviceWorkerIsRegistered }),

  [appSetServiceWorkerUpdateIsAvailable.toString()]: (state, { payload: value }) => state.merge({ serviceWorkerUpdateIsAvailable: value }),

  [coreActions.sanitize.toString()]: (state) => state.merge({ isSanitized: true }),
  [coreActions.persistDataLoadComplete.toString()]: (state) => state.merge({
    awaitingToAutoRefresh: false,
    fetchInProgress: false,
  }),

  [setAwaitingToAutoRefresh.toString()]: (state, { payload: value }) => state.set('awaitingToAutoRefresh', value),

  [createJobStatus]: (state) => state.merge({ fetchInProgress: true }),
  [deleteJobStatus]: (state) => state.merge({ fetchInProgress: false }),

  [setAppProps.toString()]: (state, { payload }) => state.mergeDeep(payload),

  [coreActions.setUpdateAllState.toString()]: (state, { payload }) => state.mergeDeep(payload),

  [importDataSuccess]:
    (state, { payload }) => state.mergeDeep({ csvImportCompleteByClientId: state.csvImportCompleteByClientId?.set(payload.clientId, payload) }),

  [importDataFailure]:
    (state, { payload }) => state.mergeDeep({ csvImportErrorByClientId: state.csvImportErrorByClientId?.set(payload.clientId, payload) }),

} as any, mkAppStore());

export const REDUCER_KEY = 'appStore';

export default reducer;
